import React from 'react';
import Firstpage from './components/Firstpage';
import CallPage from './components/CallPage';

const App = () => {
  return (
    <div>
        <Firstpage/>
        <CallPage/>      
    </div>
    
    
  )
}

export default App